import React, { useEffect, useState } from "react";
import GameCatalog from "././GameCatalog";
import { useSelector } from "react-redux";
import useSubTypeList from "../hook/useSubTypeList";
import useCasinoType from "../hook/useCasinoType";
import { filterType } from "../hook/useGameListFilter";
import { getUserGameClickList } from "../api/getApi";

const UserClickGameCatalog = ({ swiperProps }) => {
  const [userClickGames, setUserClickGames] = useState([]);
  const handleAllGame = useSelector((state) => state.isHandleAllGame);
  const casinoType = useCasinoType();

  const gameLink = useSelector((state) => state.isGameLink);

  useEffect(() => {
    getUserGameClickList()
      .then((data) => {
        setUserClickGames(data.userUserGameClick);
      })
      .catch((error) => {})
      .finally(() => {});
  }, [gameLink]);

  const clickedGames = filterType({
    gameList: userClickGames || [], // 检查userClickGames是否有数据，如果没有，使用空数组
    casinoType: casinoType,
  });

  return (
    <GameCatalog
      forceShow
      list={clickedGames}
      mainTitle={"ClickedGames"}
      wrapperClassName={clickedGames.length === 0 && "hidden"}
      typeTitle={``}
      observeFalse
      swiperProps={{
        customPerView: "game-box-layout",
      }}
    />
  );
};

export default UserClickGameCatalog;
